import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  loginMode = 'password';
  user_name: string = '';
  user_pwd: string = '';
  otp: string = '';
  otpSent = false;
  otp_result: any;
  sent_otp: any;
  user_id: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServicesService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const reason = params.get('reason');

      if (!reason) {
        return;
      }

      alert(reason);
      this.router.navigate([], {
        relativeTo: this.route,
        replaceUrl: true,
        queryParams: {},
      });
    });

    if (this.auth.isLoggedIn()) {
      this.redirectAfterLogin();
    }

    this.route.queryParamMap.subscribe((params) => {
      const mobile = params.get('mobile');
      const token = params.get('token');

      if (mobile && token) {
        this.user_name = decodeURIComponent(mobile);
        this.autoLogin(this.user_name, token);
      }
    });
  }

  setLoginMethod(mode: 'password' | 'otp') {
    this.loginMode = mode;
  }

  sendOtp(username: string) {
    if (!username) {
      alert('Please enter your mobile first');
      return;
    }

    this.otpSent = true;
    console.log('Sending OTP to:', username);

    this.service.otp(username)
      .subscribe({
        next: (data: any) => {
          console.log(data.flag);

        }
      }
      );
  }


  onLogin(user_name: any, user_pwd: any, otp: string) {
    if (this.loginMode == "password") {
      this.service.login(user_name, user_pwd).subscribe(
        (data: any) => {
          if (data.flag == true) {
            if (data.role === 'superadmin' || data.role === 'admin' || data.role === 'subadmin' || data.role === "stallowner" || data.role === "user" || data.role === "so_event_owner") {
              this.auth.storeSession(data);
              this.redirectAfterLogin();
            } else {
              alert(data.msg);
            }
          } else {
            alert(data.msg);
          }
        },
        (error: any) => {
          // Handle the error scenario
          console.error('Login request failed:', error);
          alert('Login failed: ' + (error.message || 'Unknown error'));
        });
    } else {
      // OTP mode
      if (!this.otpSent) {
        alert('Please request an OTP first');
        return;
      }

      if (!otp || otp.trim().length === 0) {
        alert('Please enter the OTP');
        return;
      }

      this.service.verify_otp(user_name, otp).subscribe(
        (data: any) => {
          if (data.flag === true) {
            this.service.login_otp(user_name).subscribe(
              (data: any) => {
                if (data.flag == true) {
                  if (data.role === 'superadmin' || data.role === 'admin' || data.role === 'subadmin' || data.role === "stallowner" || data.role === "user") {
                    this.auth.storeSession(data);
                    this.redirectAfterLogin();
                  } else {
                    alert(data.msg);
                  }
                } else {
                  alert(data.msg);
                }
              },
              (error: any) => {
                // Handle the error scenario
                console.error('Login request failed:', error);
                alert('Login failed: ' + (error.message || 'Unknown error'));
              });
          } else {
            alert(data.msg);
          }
        }, (error: any) => {
          // Handle the error scenario
          console.error('Login request failed:', error);
          alert('Login failed: ' + (error.message || 'Unknown error'));
        }
      );
    }

  }

  autoLogin(mobile: string, token: string) {
    this.service.login_catalogue(mobile, token).subscribe({
      next: (data: any) => {
        if (data.flag === true) {
          this.auth.storeSession(data);
          this.redirectAfterLogin();
        } else {
          alert(data.msg || 'User not found');
        }
      },
      error: (error: any) => {
        console.error('Auto login failed:', error);
        alert('Auto login failed');
      }
    });
  }

  private redirectAfterLogin() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || sessionStorage.getItem('ProductQrReturnUrl');
    if (returnUrl) {
      sessionStorage.removeItem('ProductQrReturnUrl');
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigateByUrl('/admin/Dashboard');
    }
  }

  goToExplore() {
    window.open('https://aieventzo.com/', '_blank');
  }


}
